import React from 'react'
import { Form, Input, Button, Checkbox, List } from 'antd'
import styled from 'styled-components'

import I18n from '@src/i18n'
import GroupService from '@services/graphQL/graphQLGroup'
import NotificationComponent from '@src/helpers/_showNotifications'

class DashboardForm extends React.Component<any, any> {
  private groupService = new GroupService()

  constructor(props: any) {
    super(props)

    this.state = {
      groups: [],
      loadingGroups: false
    }

    this.getGroups = this.getGroups.bind(this)
  }

  componentDidMount() {
    this.getGroups()
  }

  async getGroups() {
    this.setState({ loadingGroups: true })

    try {
      let { listUserGroups }: any = await this.groupService.listUserGroups()
      this.setState({ groups: listUserGroups, loadingGroups: false })
    } catch (e) {
      this.setState({ loadingGroups: false })
      NotificationComponent.Notify('error', I18n.l('common.error'), e)
      console.error(e)
    }
  }

  isChecked(id: any) {
    const { activeDashboard } = this.props
    const { groupId } = activeDashboard
    return groupId.some((r: any) => r === id)
  }

  render() {
    const { groups } = this.state
    const { onToggleModal, onSave, onChangeTitle, activeDashboard, onCheckbox } = this.props
    const { title } = activeDashboard

    return <Form>
      <Form.Item label="Nome do Dashboard">
        <Input value={title} onChange={onChangeTitle} />
      </Form.Item>

      <Form.Item>
        <ListStyle
          header="Groups"
          dataSource={groups}
          renderItem={(item: any) => <List.Item key={item.id}>
          <Checkbox
            checked={this.isChecked(item.id)}
            onChange={(e: any) => onCheckbox(item.id, e)}
          >
            {item.name}
          </Checkbox>
        </List.Item>} />
      </Form.Item>

      <Form.Item className="mb-0 text-right">
        <Button onClick={onToggleModal} type="link">
          {I18n.l('common.cancel')}
        </Button>

        <Button type="primary" className="ml-1" shape="round" onClick={onSave}>
          {I18n.l('common.save')}
        </Button>
      </Form.Item>
    </Form>
  }
}

export default DashboardForm

const ListStyle = styled(List)`
max-height: 200px;
overflow: auto;
`